// Dependencias generales
import React from "react";
import { useEffect } from 'react';

import SmartDevicesGroup from "./SmartDevicesGroup.js";
import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'

var dashboardCommonJS = require("../../js/dashboardCommon.js");

// Función del router
const SmartDevicesList = (params) => {    

    useEffect(() => {                 
      console.log("Listado dispositivos cargados correctamente.")
    }, [params.objListadoDispositivos]);

    if(params.objListadoDispositivos.length > 0){

      var tiposDeDispositivosInstalacion = []

      var tipoDispositivoActualTemp = ""

      for(var x=0; x < params.objListadoDispositivos.length; x++){   

        tipoDispositivoActualTemp = params.objListadoDispositivos[x].TipoDispositivo.split("*")[0]

        if(!tiposDeDispositivosInstalacion.includes(tipoDispositivoActualTemp)){          
          tiposDeDispositivosInstalacion.push(tipoDispositivoActualTemp)
        }
        
      }

      return (        
        <>
          {tiposDeDispositivosInstalacion.map((tipoDeDispositivoInstalacion, index) => (              
            <React.Fragment key={"SDL"+index}>
              <SmartDevicesGroup objListadoDispositivos={params.objListadoDispositivos} tipoDispositivo={tipoDeDispositivoInstalacion}/>                     
            </React.Fragment>             
          ))}          
          <div className="message info left">
            <div className="horizontal">
              <span className="material-icon size-s">info</span>
              <p className="size-s">Puedes acceder a la aplicación del fabricante pulsando en el icono a la izquierda de cada dispositivo.</p>
            </div>
          </div>
        </>
      );
    }
    else{      
      return (   
        
        <div className="message medium empty">
          <picture>
            <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
            <img src={imgNoResultsDark} alt=""/>
          </picture>

          { dashboardCommonJS.comprobarPropiedadInstalacion() === true ?
            <h1 className="title">Configura el primero pulsando en el botón de arriba</h1>
            :            
            <h1 className="title">Sólo los propietarios de la instalación pueden añadir dispositivos</h1>
          }
          <h1 className="title"></h1>
          <h1 className="title"><button className="link inline-link" onClick={() => window.location="/Advisory/ConsumptionControl"}>¿Para qué sirven?</button></h1>
                    
        </div>      
      );
    }
}

export default SmartDevicesList